import gql from 'graphql-tag';
import { participantFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const addParticipantMutation = gql`
  mutation AddParticipant($input: CreateParticipantInput!) {
    addParticipant(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminParticipantFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${participantFieldsFragment}
`;